import { PhotoFeatureCard } from '@/components';
import { PHOTO_FEATURE_CARDS_QUERYResult } from 'sanity.types';

interface PhotoFeatureCardBlockProps {
    featureCards: PHOTO_FEATURE_CARDS_QUERYResult;
}

const PhotoFeatureCardBlock = ({
    featureCards,
}: PhotoFeatureCardBlockProps) => {
    const sortedCards = [...(featureCards ?? [])].sort((a, b) => {
        const orderA = a.order ?? 0;
        const orderB = b.order ?? 0;
        return orderA - orderB;
    });

    if (sortedCards.length === 0) return null;

    return (
        <div className="mx-auto lg:w-3/4 w-full max-w-[1600px] pb-8 px-4">
            {sortedCards.map((card, idx) => {
                return (
                    <PhotoFeatureCard
                        key={idx}
                        title={card.title ?? ''}
                        copy={card.copy ?? ''}
                        imageUrl={card.imageUrl ?? ''}
                        imageAlt={card.imageAlt ?? ''}
                        index={idx}
                    />
                );
            })}
        </div>
    );
};

export default PhotoFeatureCardBlock;
